import { compose } from "redux";
import { audit } from "rxjs";
import { IAction } from "../../../../models/Action";
import { immutableSet } from "../../../../utils/immutable";
import { actionTypes } from "./actions";
import { STATE_IDENTIFIER } from "./constants";
import emptyState from "./emptyState";

const {
    ALL_AUDITS,
    RESPONSE_STATE,
    LOADER_IDENTIFIER,
} = STATE_IDENTIFIER;

const ACTION_HANDLERS = {
    [actionTypes.GET_ALL_AUDITS]: (state: any, action: any) =>
        immutableSet([LOADER_IDENTIFIER], true)(state),
    [actionTypes.GET_ALL_AUDITS_SUCCESS]: (
        state: any,
        action: any
    ) => {
        let data = {
            pageNumber: action.payload.pageNumber,
            totalElements: action.payload.totalElements,
            pageTotalNumber: action.payload.pageTotalNumber,
            pageSize: action.payload.pageSize,
            responseCode: action.payload.responseCode,
            responseStatus: action.payload.responseStatus,
            audit: [] as any[],
        };
        action.payload.audit.forEach((audit: any) => {
            data.audit.push({
                id: audit.id,
                auditDate: audit.auditDate,
                description: audit.description,
                objectDesc: audit.objectDesc,
                objectId: audit.objectId,
                objectIdentitySystemId: audit.objectIdentitySystemId,
                objectType: audit.objectType,
                operation: audit.operation,
                operationBy: audit.operationBy,
                subjectDesc: audit.subjectDesc,
                subjectId: audit.subjectId,
                subjectIdentitySystemId: audit.subjectIdentitySystemId,
                subjectType: audit.subjectType,
            });
        })
        return compose(
            immutableSet([LOADER_IDENTIFIER], false),
            immutableSet([ALL_AUDITS], data),
        )(state);
    },
    [actionTypes.GET_ALL_AUDITS_FAILURE]: (
        state: any,
        action: any
    ) => {
        return compose(
            immutableSet([LOADER_IDENTIFIER], false),
            immutableSet([ALL_AUDITS], [])
        )(state);
    },

    [actionTypes.AUDIT_RESET_STATE]: (state: any, action: any) => emptyState,

};

// Reducer
export default function communicationReducer(
    state = emptyState,
    action: IAction
) {
    if (
        action &&
        action.type === "@@router/LOCATION_CHANGE" &&
        (action.payload.location.pathname === "/welcome" ||
            action.payload.location.pathname === "/admin")
    ) {
        return emptyState;
    }
    const handler = ACTION_HANDLERS[action.type];
    return handler ? handler(state, action) : state;
}